import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select, { components } from "react-select";
import bgimage from '../../../../images/items/items.jpg';
import axios from 'axios';
import { toast } from 'react-toastify'; 

const AddItem = ({ show, onClose, onSuccess }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;

  const [itemCategoryOptions, setItemCategoryOptions] = useState([]);
  const [unitsOptions, setUnitsOptions] = useState([]);
  const [itemUnitsOptions, setItemUnitsOptions] = useState([]);
  const [MeasurementQuantityOptions, setMeasurementQuantityOptions] = useState([]);
  const [optionsSchedule, setOptionsSchedule] = useState([]);
  const [selectedSchedules, setSelectedSchedules] = useState([]);
  const [propertyTypes, setPropertyTypes] = useState([]);

  const [formData, setFormData] = useState({
    itemsubcategory: '', 
    item_name: '', 
    item_weight: '',
    units: '',
    item_size: '',
    item_units: '',
    cost: 0,  
    description: '',
    catering_corp_quantity: '',
    catering_corp_unit: '',
    per_amount:'',
  });

  const [file, setFile] = useState(null);
  const [errors, setErrors] = useState({});
  const imageInputRef = useRef(null);

  const [rawMaterial, setRawMaterial] = useState([{ id: Date.now(), propertyType: null, property: null }]);
  const [isWeightChecked, setIsWeightChecked] = useState(false);
  const [isSizeChecked, setIsSizeChecked] = useState(false);

  // Cleanup blob URL on unmount
  useEffect(() => {
    return () => {
      if (file && typeof file === 'object') {
        URL.revokeObjectURL(file);
      }
    };
  }, [file]);

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        const [scheduleRes, categoryRes, propertyRes] = await Promise.all([
          axios.get(`${baseURL}/item-schedule/items/active`),
          axios.get(`${baseURL}/grouped-item-categories`),
          fetch(`${baseURL}/property/group/list`)
        ]);

        setOptionsSchedule(scheduleRes.data.data.map(item => ({
          value: item.sno,
          label: item.itemschedule_name
        })));

        setItemCategoryOptions(categoryRes.data.data.map(category => ({
          label: category.itemcategory_name,
          options: category.subcategories.map(sub => ({
            value: sub.itemsubcategory_id,
            label: sub.itemsubcategory_name,
          }))
        })));

        await Promise.all([
          fetchUnitsByCategory(1, setUnitsOptions),
          fetchUnitsByCategory(1, setItemUnitsOptions),
          fetchUnitsByCategory(1, setMeasurementQuantityOptions)
        ]);

        const propertyData = await propertyRes.json();
        setPropertyTypes(propertyData.data.map(type => ({
          value: type.sno,
          label: type.propertytype_name,
          properties: type.properties.map(p => ({
            value: p.sno,
            label: p.property_name
          }))
        })));
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    fetchAllData();
  }, [baseURL]);

  const fetchUnitsByCategory = async (sno, setOptions) => {
    try {
      const res = await axios.get(`${baseURL}/manageunit/by-category`, {
        params: { unit_category_sno: sno },
      });
      if (res.data.success) {
        setOptions(res.data.data.map(unit => ({
          value: unit.unit_name,
          label: unit.unitslug_name,
        })));
      }
    } catch (error) {
      console.error(error);
      setOptions([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selected, name) => {
    setFormData(prev => ({ ...prev, [name]: selected?.value || '' }));
  };

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) setFile(selectedFile);
  };

  const removeImage = () => {
    if (file && typeof file === 'object') URL.revokeObjectURL(file);
    setFile(null);
    if (imageInputRef.current) imageInputRef.current.value = '';
  };

  const validateForm = () => {
    const formErrors = {};
    if (!formData.catering_corp_quantity) formErrors.catering_corp_quantity = "Valid quantity is required";
    if (!formData.catering_corp_unit) formErrors.catering_corp_unit = "Unit is required";
    if (!formData.itemsubcategory) formErrors.itemsubcategory = "Item Category is required";
    if (!formData.item_name.trim()) formErrors.item_name = "Item Name is required";
    // if (!formData.per_amount || isNaN(formData.per_amount) || parseFloat(formData.per_amount) <= 0) formErrors.per_amount = "Valid amount is required";
    if (!formData.per_amount || isNaN(formData.per_amount) || parseFloat(formData.per_amount) <= 0) {
      formErrors.per_amount = "Valid amount is required";
    }

    if (isWeightChecked) {
      if (!formData.item_weight || isNaN(formData.item_weight) || parseFloat(formData.item_weight) <= 0) formErrors.item_weight = "Valid weight is required";
      if (!formData.units) formErrors.units = "Weight unit is required";
    }

    if (isSizeChecked) {
      if (!formData.item_size || isNaN(formData.item_size) || parseFloat(formData.item_size) <= 0) formErrors.item_size = "Valid size is required";
      if (!formData.item_units) formErrors.item_units = "Size unit is required";
    }

    if (selectedSchedules.length === 0) formErrors.schedule = "At least one schedule is required";

    rawMaterial.forEach((r, i) => {
      if (!r.propertyType) formErrors[`propertyType_${i}`] = "Property type required";
      if (!r.property) formErrors[`property_${i}`] = "Property required";
    });

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) payload.append(key, value);
    });

    selectedSchedules.forEach(s => payload.append('schedule[]', s.value));
    if (file) payload.append('item_image', file);

    rawMaterial.forEach((r, i) => {
      payload.append(`property[${i}][property_type_id]`, r.propertyType.value);
      payload.append(`property[${i}][property_id]`, r.property.value);
    });

    try {
      await axios.post(`${baseURL}/manage-items`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success("Item Created Successfully!");
      if (onSuccess) onSuccess();
      handleClose();
    } catch (error) {
      console.error('Submit error:', error.response?.data || error);
    }
  };

  const handleAddConfig = () => setRawMaterial([...rawMaterial, { id: Date.now(), propertyType: null, property: null }]);
  const handleDeleteConfig = (id) => setRawMaterial(rawMaterial.filter(r => r.id !== id));

  const handleCheckboxChange = (e, type) => {
    const checked = e.target.checked;
    if (type === "weight") setIsWeightChecked(checked);
    if (type === "size") setIsSizeChecked(checked);
  };

  const handlePropertyTypeChange = (selected, index) => {
    const updated = [...rawMaterial];
    updated[index].propertyType = selected;
    updated[index].property = null;
    setRawMaterial(updated);
  };

  const handlePropertyChange = (selected, index) => {
    const updated = [...rawMaterial];
    updated[index].property = selected;
    setRawMaterial(updated);
  };

  const customStyles = { groupHeading: (provided) => ({ ...provided, fontSize: '14px', fontWeight: 'bold', color: '#333' }) };
  const Group = (props) => <div style={customStyles}><components.Group {...props} /></div>;

  const handleClose = () => {
    setFormData({
      itemsubcategory: '',
      item_name: '',  
      item_weight: '',
      units: '',
      item_size: '',
      item_units: '',
      cost: 0,
      description: '',
      catering_corp_quantity: '',
      catering_corp_unit: '',
      per_amount:'',
    });
    setSelectedSchedules([]);
    setErrors({});
    setRawMaterial([{ id: Date.now(), propertyType: null, property: null }]);
    setIsWeightChecked(false);
    setIsSizeChecked(false);
    removeImage();
    onClose();
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Item</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={handleClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="row">
              {/* Item Category */}
              <div className="col-lg-6 mb-4">
                <label className="text-black font-w500 fs-7">
                  Item Category / Sub category <span className="required">*</span>
                </label>
                <Select
                  options={itemCategoryOptions}
                  onChange={selected => handleSelectChange(selected, 'itemsubcategory')}
                  name="itemsubcategory"
                  components={{ Group }}
                  styles={customStyles}
                  placeholder="Select Item Category"
                  value={
                    (() => {
                      for (let group of itemCategoryOptions) {
                        const found = group.options.find(o => o.value === formData.itemsubcategory);
                        if (found) return found;
                      }
                      return null;
                    })()
                  }
                />
                {errors.itemsubcategory && <span className="text-danger">{errors.itemsubcategory}</span>}
              </div>

              {/* Item Name */}
              <div className="col-lg-6 mb-4">
                <label className="text-black font-w500 fs-7">Item Name <span className="required">*</span></label>
                <input type="text" name="item_name" className="form-control" placeholder="Enter Item Name" value={formData.item_name} onChange={handleInputChange} />
                {errors.item_name && <span className="text-danger">{errors.item_name}</span>}
              </div>
            </div>

            {/* Quantity & Amount */}
            <div className="row">
              <div className="col-lg-6 mb-2">
                <div className="row">
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Item Quantity (per Person)<span className="required">*</span></label>
                    <input type="text" name="catering_corp_quantity" className="form-control" placeholder="Enter per person" value={formData.catering_corp_quantity} onChange={handleInputChange} />
                    {errors.catering_corp_quantity && <span className="text-danger">{errors.catering_corp_quantity}</span>}
                  </div>
                  <div className="col-lg-6 mb-4">
                    <label className="text-black font-w500 fs-7">Quantity Unit (per Person)<span className="required">*</span></label>
                    <Select
                      placeholder="Select Unit"
                      options={MeasurementQuantityOptions}
                      value={MeasurementQuantityOptions.find(opt => opt.value === formData.catering_corp_unit) || null}
                      onChange={selected => handleSelectChange(selected, 'catering_corp_unit')}
                    />
                    {errors.catering_corp_unit && <span className="text-danger">{errors.catering_corp_unit}</span>}
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-6 mb-4">
                <label className="text-black font-w500 fs-7">Per Person Amount <span className="required">*</span></label>
                <input type="text" name="per_amount" className="form-control" placeholder="Enter Per Amount" value={formData.per_amount} onChange={handleInputChange} />
                {errors.per_amount && <span className="text-danger">{errors.per_amount}</span>}
              </div> */}
              <div className="col-lg-6 mb-4">
                <label className="text-black font-w500 fs-7">
                  Per Person Amount <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="per_amount"
                  className="form-control"
                  placeholder="Enter Per Amount"
                  value={formData.per_amount}
                  onChange={handleInputChange}
                  maxLength={11} // <-- limit input to 11 characters
                />
                {errors.per_amount && <span className="text-danger">{errors.per_amount}</span>}
              </div>

            </div>
 


            {/* Weight & Size Section */}
<div className="row">
  {/* Weight Section */}
  <div className="col-lg-6">
    <div className="row">
      <div className="col-lg-6">
        <div className="form-check custom-checkbox mb-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            id="weightCheck"
            checked={isWeightChecked}
            onChange={(e) => handleCheckboxChange(e, 'weight')}
          />
          <label className="text-black font-w500 fs-7" htmlFor="weightCheck">
            Item Weight {isWeightChecked && <span className="required">*</span>}
          </label>
        </div>
        <input
          type="text"
          name="item_weight"
          className="form-control"
          placeholder="Enter Weight"
          value={formData.item_weight}
          onChange={handleInputChange}
          readOnly={!isWeightChecked}
        />
        {errors.item_weight && (
          <span className="text-danger">{errors.item_weight}</span>
        )}
      </div>

      <div className="col-lg-6">
        <label className="text-black font-w500 fs-7">
          Weight Unit {isWeightChecked && <span className="required">*</span>}
        </label>
        <Select
          placeholder="Select Units"
          options={unitsOptions}
          value={unitsOptions.find(opt => opt.value === formData.units) || null}
          onChange={(selected) => handleSelectChange(selected, 'units')}
          isDisabled={!isWeightChecked}
        />
        {errors.units && (
          <span className="text-danger">{errors.units}</span>
        )}
      </div>
    </div>
  </div>

  {/* Size Section */}
  <div className="col-lg-6">
    <div className="row">
      <div className="col-lg-6">
        <div className="form-check custom-checkbox mb-2">
          <input
            type="checkbox"
            className="form-check-input me-2"
            id="sizeCheck"
            checked={isSizeChecked}
            onChange={(e) => handleCheckboxChange(e, 'size')}
          />
          <label className="text-black font-w500 fs-7" htmlFor="sizeCheck">
            Item Size {isSizeChecked && <span className="required">*</span>}
          </label>
        </div>
        <input
          type="text"
          name="item_size"
          className="form-control"
          placeholder="Enter Size"
          value={formData.item_size}
          onChange={handleInputChange}
          readOnly={!isSizeChecked}
        />
        {errors.item_size && (
          <span className="text-danger">{errors.item_size}</span>
        )}
      </div>

      <div className="col-lg-6">
        <label className="text-black font-w500 fs-7">
          Size Unit {isSizeChecked && <span className="required">*</span>}
        </label>
        <Select
          placeholder="Select Units"
          options={itemUnitsOptions}
          value={itemUnitsOptions.find(opt => opt.value === formData.item_units) || null}
          onChange={(selected) => handleSelectChange(selected, 'item_units')}
          isDisabled={!isSizeChecked}
        />
        {errors.item_units && (
          <span className="text-danger">{errors.item_units}</span>
        )}
      </div>
    </div>
  </div>

  {/* Schedule */}
  <div className="col-lg-6 mb-4">
    <label className="text-black font-w500 fs-7">Item Schedule <span className="required">*</span></label>
    <Select
      isMulti
      placeholder="Select Schedule(s)"
      value={selectedSchedules}
      onChange={setSelectedSchedules}
      options={optionsSchedule}
    />
    {errors.schedule && <span className="text-danger">{errors.schedule}</span>}
  </div>

  {/* Description */}
  <div className="col-lg-6 mb-4">
    <label className="text-black font-w500 fs-7">Description</label>
    <textarea
      className="form-control"
      name="description"
      placeholder="Description"
      value={formData.description}
      onChange={handleInputChange}
    />
  </div>

  {/* Item Image */}
  <div className="col-lg-6 mb-4">
    <label className="text-black font-w500 fs-7">Item Image</label>
    <div className="avatar-upload d-flex align-items-center">
      <div className="change position-relative px-0">
        <div className="avatar-preview h-100px w-100px border" style={{ borderRadius: '10px' }}>
          <img
            src={file ? URL.createObjectURL(file) : bgimage}
            alt="Item"
            className="p-1 h-100px w-100px"
            style={{ objectFit: 'cover', borderRadius: '10px' }}
          />
        </div>
        <div className="change-btn mt-2 d-flex justify-content-center gap-3">
          <Button className="btn-xs" variant="success" onClick={() => imageInputRef.current.click()}>
            <i className="fa fa-upload fs-4" />
          </Button>
          <Button className="btn-xs" variant="danger" onClick={removeImage}>
            <i className="fa fa-close fs-4" />
          </Button>
          <input
            type="file"
            accept=".png,.jpg,.jpeg"
            style={{ display: 'none' }}
            onChange={handleImageChange}
            ref={imageInputRef}
          />
        </div>
     
      </div>
    </div>
  </div>
</div>


            {/* Raw Materials */}
            <div className="row mt-3">
              <div className="scroll-y mh-350px py-2 col-lg-12">
                {rawMaterial.map((config, index) => (
                  <div key={config.id} className="row mb-3">
                    <div className="col-lg-4 mb-4">
                      <label className="text-black font-w500 fs-7">Item Property Type<span className="required">*</span></label>
                      <Select placeholder="Select Type" value={config.propertyType} options={propertyTypes} onChange={(sel) => handlePropertyTypeChange(sel, index)} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} menuPortalTarget={document.body} />
                      {errors[`propertyType_${index}`] && <div className="text-danger small">{errors[`propertyType_${index}`]}</div>}
                    </div>
                    <div className="col-lg-4 mb-4">
                      <label className="text-black font-w500 fs-7">Item Property<span className="required">*</span></label>
                      <Select placeholder="Select Property" value={config.property} options={config.propertyType ? config.propertyType.properties : []} onChange={(sel) => handlePropertyChange(sel, index)} styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }} menuPortalTarget={document.body} isDisabled={!config.propertyType} />
                      {errors[`property_${index}`] && <div className="text-danger small">{errors[`property_${index}`]}</div>}
                    </div>
                    <div className="col-lg-1 mb-1 d-flex align-items-center">
                      {rawMaterial.length > 1 && <Button variant="danger" className="mt-4 px-2 py-2" onClick={() => handleDeleteConfig(config.id)}><i className="fa-solid fa-trash-can fs-6 text-white"></i></Button>}
                    </div>
                  </div>
                ))}
                <Button variant="primary" size="sm" onClick={handleAddConfig}><i className="fa-solid fa-plus fs-6"></i> Add More</Button>
              </div>
            </div>

            {/* Submit */}
            <div className="d-flex align-items-center justify-content-end gap-3 mt-4 mb-4">
              <button type="submit" className="btn btn-sm btn-primary">Create Item <i className="fas fa-angle-double-right ms-2"></i></button>
            </div>

          </div>
        </form>
      </div>
    </Modal>
  );
};

export default AddItem;
